/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserFlagsModeratorControllerPatchMutationRequest,
  UserFlagsModeratorControllerPatchMutationResponse,
  UserFlagsModeratorControllerPatchPathParams,
  UserFlagsModeratorControllerPatch401,
  UserFlagsModeratorControllerPatch404,
} from '../types/UserFlagsModeratorControllerPatch.ts';

function getUserFlagsModeratorPatchUrl(id: UserFlagsModeratorControllerPatchPathParams['id']) {
  const res = { method: 'PATCH', url: `/api/moderator/user-flags/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/user-flags/:id}
 */
export async function userFlagsModeratorPatch(
  id: UserFlagsModeratorControllerPatchPathParams['id'],
  data?: UserFlagsModeratorControllerPatchMutationRequest,
  config: Partial<RequestConfig<UserFlagsModeratorControllerPatchMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UserFlagsModeratorControllerPatchMutationResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerPatch401 | UserFlagsModeratorControllerPatch404>,
    UserFlagsModeratorControllerPatchMutationRequest
  >({ method: 'PATCH', url: getUserFlagsModeratorPatchUrl(id).url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
